"use strict";

var __assign = function () {
  return (__assign = Object.assign || function (t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);

    return t;
  }).apply(this, arguments);
},
    common_1 = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getTransformMatrix = exports.getTranslateXProperty = exports.getTouchmoveTranslatePosition = exports.getTranslate3dProperty = exports.getRenderStageItemStyles = exports.getRenderStageStyles = exports.getTransitionProperty = exports.getRenderWrapperStyles = exports.animate = exports.shouldHandleResizeEvent = exports.getElementFirstChild = exports.getElementCursor = exports.getAutoheightProperty = exports.getElementDimensions = exports.getItemWidth = exports.createDefaultTransformationSet = exports.createAutowidthTransformationSet = exports.isElement = exports.createClones = exports.getItemsOffset = exports.getItemsCount = exports.getSlides = void 0, require("./common")),
    mappers_1 = require("./mappers"),
    math_1 = require("./math");

function getElementDimensions(t) {
  return t && t.getBoundingClientRect ? {
    width: (t = t.getBoundingClientRect()).width,
    height: t.height
  } : {
    width: 0,
    height: 0
  };
}

function shouldHandleResizeEvent(t, e, r) {
  return (e = void 0 === e ? {} : e).width !== (r = void 0 === r ? {} : r).width;
}

function animate(t, e) {
  var e = e || {},
      r = e.position,
      r = void 0 === r ? 0 : r,
      n = e.animationDuration,
      n = void 0 === n ? 0 : n,
      e = e.animationEasingFunction,
      e = void 0 === e ? "ease" : e;
  return exports.isElement(t) && (t.style.transition = "transform " + n + "ms " + e + " 0ms", t.style.transform = "translate3d(" + r + "px, 0, 0)"), t;
}

function getTranslateXProperty(t) {
  t = getTransformMatrix(t), t = t && t[4] || "";
  return Number(t);
}

function getTransformMatrix(t) {
  return exports.isElement(t) && getComputedStyle(t).transform.match(/(-?[0-9.]+)/g) || [];
}

exports.getSlides = function (t) {
  var e = t.children,
      t = t.items;
  return e ? e.length ? e : [e] : void 0 === t ? [] : t;
}, exports.getItemsCount = function (t) {
  return exports.getSlides(t).length;
}, exports.getItemsOffset = function (t) {
  var e = t.infinite,
      r = t.paddingRight,
      t = t.paddingLeft;
  return e && (t || r) ? 1 : 0;
}, exports.createClones = function (t) {
  var e = exports.getSlides(t);
  if (!t.infinite) return e;
  var r = exports.getItemsCount(t),
      n = exports.getItemsOffset(t),
      t = common_1.getItemsInSlide(r, t),
      o = Math.min(t, r) + n,
      i = e.slice(0, o),
      o = e.slice(-o);
  return n && t === r && (n = e[0], t = e.slice(-1)[0], o.unshift(t), i.push(n)), o.concat(e, i);
}, exports.isElement = function (t) {
  try {
    return t instanceof Element || t instanceof HTMLDocument;
  } catch (t) {
    return !1;
  }
}, exports.createAutowidthTransformationSet = function (t, i, e) {
  void 0 === i && (i = 0), void 0 === e && (e = !1);
  var s = 0,
      a = !0,
      r = [];
  return exports.isElement(t) && (r = Array.from(t.children || []).reduce(function (t, e, r) {
    var n = 0,
        r = r - 1,
        o = t[r],
        e = getElementDimensions(null == e ? void 0 : e.firstChild).width,
        e = void 0 === e ? 0 : e;
    return a = (s += e) <= i, o && (n = 0 == r ? o.width : o.width + o.position), t.push({
      position: n,
      width: e
    }), t;
  }, []), e || (r = a ? mappers_1.mapPartialCoords(r) : (t = s - i, mappers_1.mapPositionCoords(r, t)))), {
    coords: r,
    content: s,
    partial: a
  };
}, exports.createDefaultTransformationSet = function (t, o, e, r) {
  void 0 === r && (r = !1);
  var i = 0,
      s = !0,
      n = [],
      a = exports.getItemWidth(o, e);
  return n = t.reduce(function (t, e, r) {
    var n = 0,
        r = t[r - 1];
    return s = (i += a) <= o, r && (n = a + r.position || 0), t.push({
      width: a,
      position: n
    }), t;
  }, []), {
    coords: n = r ? n : s ? mappers_1.mapPartialCoords(n) : (e = i - o, mappers_1.mapPositionCoords(n, e)),
    content: i,
    partial: s
  };
}, exports.getItemWidth = function (t, e) {
  return 0 < e ? t / e : t;
}, exports.getElementDimensions = getElementDimensions, exports.getAutoheightProperty = function (t, e, r) {
  var e = exports.getElementCursor(e, r),
      r = exports.getElementFirstChild(t, e);
  if (exports.isElement(r)) return t = getComputedStyle(r), e = parseFloat(t.marginTop), t = parseFloat(t.marginBottom), Math.ceil(r.offsetHeight + e + t);
}, exports.getElementCursor = function (t, e) {
  var r = e.activeIndex,
      e = e.itemsInSlide;
  return t.infinite ? r + e + exports.getItemsOffset(t) : r;
}, exports.getElementFirstChild = function (t, e) {
  t = t && t.children || [];
  return t[e] && t[e].firstChild || null;
}, exports.shouldHandleResizeEvent = shouldHandleResizeEvent, exports.animate = animate, exports.getRenderWrapperStyles = function (t, e, r) {
  var n = t || {},
      o = n.paddingLeft,
      i = n.paddingRight,
      s = n.autoHeight,
      n = n.animationDuration,
      s = s ? exports.getAutoheightProperty(r, t, e) : void 0;
  return {
    height: s,
    transition: s ? "height " + n + "ms" : void 0,
    paddingLeft: o + "px",
    paddingRight: i + "px"
  };
}, exports.getTransitionProperty = function (t) {
  var t = t || {},
      e = t.animationDuration,
      t = t.animationEasingFunction;
  return "transform " + (void 0 === e ? 0 : e) + "ms " + (void 0 === t ? "ease" : t) + " 0ms";
}, exports.getRenderStageStyles = function (t, e) {
  t = (t || {}).translate3d, t = "translate3d(" + -(void 0 === t ? 0 : t) + "px, 0, 0)";
  return __assign(__assign({}, e), {
    transform: t
  });
}, exports.getRenderStageItemStyles = function (t, e) {
  var r = e.transformationSet,
      n = e.fadeoutAnimationIndex,
      o = e.fadeoutAnimationPosition,
      i = e.fadeoutAnimationProcessing,
      e = e.animationDuration,
      r = (r[t] || {}).width;
  return i && n === t ? {
    transform: "translateX(" + o + "px)",
    animationDuration: e + "ms",
    width: r + "px"
  } : {
    width: r
  };
}, exports.getTranslate3dProperty = function (t, e) {
  var r = t,
      n = e.infinite,
      o = e.itemsOffset,
      i = e.itemsInSlide,
      e = e.transformationSet;
  return ((void 0 === e ? [] : e)[r = n ? t + math_1.getShiftIndex(void 0 === i ? 0 : i, void 0 === o ? 0 : o) : r] || {}).position || 0;
}, exports.getTouchmoveTranslatePosition = function (t, e) {
  return -(e - Math.floor(t));
}, exports.getTranslateXProperty = getTranslateXProperty, exports.getTransformMatrix = getTransformMatrix;